<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
    export default {
        name: "Settings",
        data() {
            return {
                msg: 'Hello World!',
            }
        },
    }
</script>

<style scoped>

</style>
